import { GET_FMUPROEVE_DELTAGER_INFO } from "@/api/kursus/queries";
import { AlertMessage } from "@/components/AlertMessage";
import {
  TicketHeading,
  TicketRoot,
  TicketSub,
  TicketSubItem,
} from "@/components/ticket/Ticket";
import { PersonDto } from "@/interfaces/schema";
import { useQuery } from "@apollo/client";

export default function FmuProeveDeltagerInfo(props: { personId: string }) {
  const { personId } = props;
  const { data } = useQuery<{ person: PersonDto }>(
    GET_FMUPROEVE_DELTAGER_INFO(),
    {
      variables: {
        id: personId ?? "",
      },
      skip: !personId,
    },
  );

  if (!data) {
    return null;
  }
  const info = extractInfo(data.person);

  return (
    <AlertMessage type="info" className="w-100">
      {info.eksamener.length > 0 && (
        <>
          <p>
            Deltageren er tilmeldt {info.eksamener.length}
            {info.eksamener.length === 1 ? " eksamen" : " eksamener"}
          </p>

          {info.eksamener.map((eksamen) => (
            <TicketRoot
              icon="arrow"
              className="bg-white shadow-sm mb-4"
              key={eksamen.kursusId}
              onClick={() =>
                window.open(
                  `/kursus/${eksamen.kursusId}`,
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              <TicketHeading>
                <h4>{eksamen.kursusNavn}</h4>
              </TicketHeading>
              <TicketSub>
                <TicketSubItem>
                  Bestået:{" "}
                  {eksamen.bestaaet
                    ? eksamen.bestaaet.charAt(0).toUpperCase() +
                      eksamen.bestaaet.slice(1).toLowerCase()
                    : ""}
                </TicketSubItem>
              </TicketSub>
            </TicketRoot>
          ))}
        </>
      )}
      {info.kurser.length > 0 && (
        <p>
          Deltageren er tilmeldt {info.kurser.length}
          {info.kurser.length === 1 ? " kursus" : " kurser"}
        </p>
      )}
      {info.kurser.map((kursus) => (
        <TicketRoot
          icon="arrow"
          className="bg-white shadow-sm mb-4"
          key={kursus.kursusId}
          onClick={() =>
            window.open(
              `/kursus/${kursus.kursusId}`,
              "_blank",
              "noopener,noreferrer",
            )
          }
        >
          <TicketHeading>
            <h4>{kursus.kursusNavn}</h4>
          </TicketHeading>
          <TicketSub>
            <TicketSubItem>
              Deltagerstatus: {kursus.kursusStatus ?? "Ikke angivet"}
            </TicketSubItem>
            <TicketSubItem> | </TicketSubItem>
            <TicketSubItem>
              Fakturastatus: {kursus.fakturaStatus ?? "Ikke angivet"}
            </TicketSubItem>
          </TicketSub>
        </TicketRoot>
      ))}
    </AlertMessage>
  );
}

function extractInfo(person: PersonDto) {
  const kursusPerson =
    person.kursusPerson
      ?.sort((a, b) => {
        return (
          new Date(a.hold.tilDato).getTime() -
          new Date(b.hold.tilDato).getTime()
        );
      })
      .map((kursusPerson) => {
        return {
          kursusId: kursusPerson.hold.id,
          kursusNavn: kursusPerson.hold.navn,
          bestaaet: kursusPerson.bestaaetMark,
          fakturaStatus: kursusPerson.fakturaStatusNavigation?.navn,
          kursusStatus: kursusPerson.deltagerStatusNavigation?.navn,
          kursusType: kursusPerson.hold.kursustypeNavigation?.nr,
        };
      }) ?? [];

  return {
    kurser: kursusPerson
      ? kursusPerson.filter((kursusPerson) => kursusPerson.kursusType === 3)
      : [],
    eksamener: kursusPerson
      ? kursusPerson.filter((kursusPerson) => kursusPerson.kursusType === 5)
      : [],
  };
}
